const styles = theme => ({
  container: {
    height: "100%",
    display: "flex",
    position: "relative"
  },
  left: {
    flexBasis: "40%",
    backgroundColor: "rgba(255,255,255,0.38)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.sharp,
      duration: ".5s"
    })
  },
  leftIn: {
    opacity: 1
  },
  number: {
    fontFamily: "Oswald",
    fontWeight: 500,
    fontSize: "4.5rem",
    color: theme.palette.common.white
  },
  right: {
    flexGrow: 1,
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing.unit * 2,
    opacity: 0,
    transition: theme.transitions.create(["opacity", "padding-left"], {
      easing: theme.transitions.easing.sharp,
      duration: ".5s"
    })
  },
  rightIn: {
    paddingLeft: theme.spacing.unit * 6,
    opacity: 1
  },
  name: {
    fontFamily: "Oswald",
    color: theme.palette.common.white,
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "2.2rem",
    lineHeight: "2.1rem"
  },
  thankYou: {
    color: theme.palette.common.white,
    fontWeight: 100,
    fontSize: "1.5rem"
  },
  placeDonationText: {
    color: theme.palette.common.white,
    fontWeight: 100,
    fontSize: "2.4rem",
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/Shoutouts/styles.js